module.exports = __webpack_public_path__ + "img/nav-design-fancy.7b9816f.jpg";